import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";

import ScrollToTop from "./components/routing/ScrollToTop";

import LandingPage from "./pages/LandingPage";
import OldBoysAssociationPage from "./pages/OldBoysAssociationPage";
import OldBoysAssociationHistoryPage from "./pages/OldBoysAssociationHistoryPage";

import NewsFeedPage from "./pages/NewsFeedPage";
// import NewsDetailPage from "./pages/NewsDetailPage";
// import NewsPublishPage from "./pages/NewsPublishPage";

// import EventsPage from "./pages/EventsPage";
// import EventDetailsPage from "./pages/EventDetailsPage";
// import EventPublishPage from "./pages/EventPublishPage";

import MemberRegistrationPage from "./pages/MemberRegistrationPage";
import MembershipRequestTrackingPage from "./pages/MembershipRequestTrackingPage";
import MembershipRequestPage from "./pages/MembershipRequestPage";
import MembershipRequestsPage from "./pages/MembershipRequestsPage";

import ExCoPortalPage from "./pages/ExCoPortalPage";
import ContactPage from "./pages/ContactPage";

import NotFoundPage from "./pages/NotFoundPage";

import { MembershipRegistrationProvider } from "./context/MembershipRegistrationContext";
import { MembershipRequestsProvider } from "./context/MembershipRequestsContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<LandingPage />} />

      <Route
        path="/old-boys-association"
        element={<OldBoysAssociationPage />}
      />

      <Route
        path="/old-boys-association/history"
        element={<OldBoysAssociationHistoryPage />}
      />

      <Route path="/news-feed" element={<NewsFeedPage />} />

      {/* <Route path="/voice-of-vidyaloka/:id" element={<NewsDetailPage />} /> */}

      {/* <Route path="/events" element={<EventsPage />} /> */}

      {/* <Route path="/events/:id" element={<EventDetailsPage />} /> */}

      <Route
        path="/membership/register"
        element={
          <MembershipRegistrationProvider>
            <MemberRegistrationPage />
          </MembershipRegistrationProvider>
        }
      />
      <Route
        path="/membership/track-request"
        element={<MembershipRequestTrackingPage />}
      />

      <Route path="/exco-portal" element={<ExCoPortalPage />} />

      <Route
        path="/exco-portal/membership-requests"
        element={
          <MembershipRequestsProvider>
            <MembershipRequestsPage />
          </MembershipRequestsProvider>
        }
      />
      <Route
        path="/exco-portal/membership-requests/:referenceId"
        element={
          <MembershipRequestsProvider>
            <MembershipRequestPage />
          </MembershipRequestsProvider>
        }
      />

      {/* <Route
        path="/exco-portal/voice-of-vidyaloka/publish"
        element={<NewsPublishPage />}
      />

      <Route
        path="/exco-portal/voice-of-vidyaloka/publish"
        element={<NewsPublishPage />}
      />

      <Route
        path="/exco-portal/events/publish"
        element={<EventPublishPage />}
      /> */}

      <Route path="/contact" element={<ContactPage />} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </BrowserRouter>,
);
